import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { GetSpecificTaskById } from "../../Redux/Reducers/Manager/Tasks/TasksByRoundAndFiled";
import { useDispatch, useSelector } from "react-redux";
import SummaryInfo from "../../Pages/Manager/SummaryInfo";

function SummaryInformation() {
  const { taskId } = useParams();
  const [taskDisabledStatus, setTaskDisabledStatus] = useState(false);
  const dispatch = useDispatch();
  const applicationGuid = useSelector(
    (state) => state.TasksByRoundAndFiled.SpecificTask
  );

  // useEffect(() => {
  //   dispatch(GetSpecificTaskById({ taskId: taskId }));
  // }, [taskId]);

  return (
    <>
      <SummaryInfo taskId={taskId} />
    </>
  );
}

export default SummaryInformation;
